import { Paper, PaperProps } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { CSSProperties, ReactElement } from "react";
import Text, { Variant } from "./Text";

interface Props extends PaperProps {
  children?: ReactElement | ReactElement[];
  color?: string;
  fullWidth?: boolean;
  customClass?: string;
  otherStyles?: CSSProperties;
  label?: string;
  labelVariant?: Variant;
}

const CustomPaper = ({
  fullWidth,
  children,
  color,
  customClass,
  otherStyles,
  label,
  labelVariant,
  ...other
}: Props) => {
  const theme = useTheme();

  return (
    <Paper
      {...other}
      elevation={0}
      className={`base-adron-paper ${customClass}`}
      style={{
        width: fullWidth ? "100%" : "auto",
        backgroundColor: color ? color : theme.myTheme.colors.gray400,
        ...otherStyles,
      }}
    >
      {label && <Text variant={labelVariant ? labelVariant : "s"}>{label}</Text>}
      {children}
    </Paper>
  );
};

export default CustomPaper;
